import React from 'react';
import JavascriptRegexp from './JavascriptRegexp.jsx';
import JavascriptRegexpFlags from './JavascriptRegexpFlags.jsx';
import JavascriptRegexpClasses from './JavascriptRegexpClasses.jsx';
import JavascriptRegexpMetachars from './JavascriptRegexpMetachars.jsx';
import JavascriptRegexpAssertions from './JavascriptRegexpAssertions.jsx';
import JavascriptRegexpQuantifiers from './JavascriptRegexpQuantifiers.jsx';
import JavascriptRegexpPatterns from './JavascriptRegexpPatterns.jsx';
import JavascriptRegexpObjects from './JavascriptRegexpObjects.jsx';
import JavascriptRegexpMethods from './JavascriptRegexpMethods.jsx';

export default function JsRegexp() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS RegExp</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/regexp' className='underline'>JS RegExp</a></li>
<li><a href='/javascript/regexp/flags' className='underline'>JS RegExp Flags</a></li>
<li><a href='/javascript/regexp/classes' className='underline'>JS RegExp Classes</a></li>
<li><a href='/javascript/regexp/metachars' className='underline'>JS RegExp Metachars</a></li>
<li><a href='/javascript/regexp/assertions' className='underline'>JS RegExp Assertions</a></li>
<li><a href='/javascript/regexp/quantifiers' className='underline'>JS RegExp Quantifiers</a></li>
<li><a href='/javascript/regexp/patterns' className='underline'>JS RegExp Patterns</a></li>
<li><a href='/javascript/regexp/objects' className='underline'>JS RegExp Objects</a></li>
<li><a href='/javascript/regexp/methods' className='underline'>JS RegExp Methods</a></li>
      </ul>
    </div>
  );
}
